const NS = 'InstagramBlock';
const CLS = 'instagramBlock';
const WG = '.' + CLS + '-';

import Instafeed from 'instafeed.js'; //import the instafeed

export class InstagramBlock {
	constructor($el) {
		// $el is the widget node return by the loadShopProductBlock function
		this.$el = $($el);
		// get the data from epi server
		var readMore = this.$el.data("readMore");
		var topLogo = this.$el.data("topLogo");
		var sideLogo = this.$el.data("sideLogo");
		var isScroll = this.$el.data("isScroll");
		var insToken = this.$el.data("insToken");
		// load the instafeed
		var userFeed = new Instafeed({
			get: 'user',
			target: "instafeed-container", // insert instagram into this div
			resolution: 'low_resolution', // using low resolution image
			limit: 12, // show 12 posts in the carousel
			accessToken: insToken,
			// create custom template
			template:'<div class="instaPost"><div class="instaTop"><img class="woolmarkLogo" src="'+ topLogo +'"><h5><b>thewoolmarkcompany</b></h5><img class="instaLogo" src="' + sideLogo+ '"><p class="instaCaption">{{caption}}</p><a href="{{link}}"><b>' + readMore +'</b></a></div><a href="{{link}}"><img title="{{caption}}" src="{{image}}" /></a></div>'
		});
		userFeed.run();

		// load slick slider 
		setTimeout(slickFunction, 2000); // wait for 2 seconds until instagram feed is fully loaded then load slick slider
			function slickFunction() {
				$("#instafeed-container").slick({
						dots: true,
						infinite: true,
						autoplay: isScroll,
    					autoplaySpeed: 4000,
						slidesToShow: 3,
						slidesToScroll: 3,
						responsive: [
						{
							breakpoint: 1024,
							settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							}
						},
						{
							breakpoint: 600,
							settings: {
							slidesToShow: 2,
							slidesToScroll: 2
							}
						},
						{
							breakpoint: 480,
							settings: {
							slidesToShow: 1,
							slidesToScroll: 1
							}
						}
						]
				});
				$('#instafeed-container').show();
			}
	}
	// Add more functions like on above here
}
